import React from "react";
import { Routes, Route } from "react-router-dom";
import DomainSideBar from "./classes/layout/SideBar/domain";
import UserSideBar from "./classes/layout/SideBar/user";
import Restore from "./Restore.js";
import GetFiles from "./classes/homepage/services/getFiles";
import PriceList from "./classes/homepage/repair/priceList";

class BrtxRoutes extends React.Component {

 render() {
    const { Placeholder, loader, BrtxRoute, Config } = this.props;
    return (
      <>
        {this.props.screen.width > 767 &&
          this.props.user.type === "domain" && <DomainSideBar {...this.props} />}
        {this.props.screen.width > 767 &&
          this.props.user.type === "user" && <UserSideBar {...this.props} />}

        <BrtxRoute {...this.props.headerPage} {...Config({ DefaultRoutes: true }).filter((f) => f.element === "Header")[0]} />

        {loader.open && loader?.placeholder && (
          <Placeholder line={[{ size: 6 }, { size: 3 }, { size: 9 }]} />
        )}

        <Routes>
          <Route path="/GetFile/:id" element={<GetFiles {...this.props} />} />
          <Route path="/PriceList/noui" element={<PriceList {...this.props} />} />
          <Route path="/Restore" element={<Restore />} />
          {/* Základní routy */}
          {Config({ DefaultRoutes: true }).filter((f) => f.route !== "").map((route) => (
            <>
              {route.children === undefined && (
                <Route path={route.route} element={<BrtxRoute {...this.props} {...route} />} />
              )}
              {route.children !== undefined && (
                <Route path={route.route}>
                  <>
                    <Route index element={<BrtxRoute {...this.props} {...route} />} />
                    {route.children.map((ch) => (
                      <>
                        {ch.children === undefined && (
                          <Route path={ch.route} element={<BrtxRoute {...this.props} {...ch} />} />
                        )}
                        {ch.children !== undefined && (
                          <Route path={ch.route}>
                            <>
                              <Route index element={<BrtxRoute {...this.props} {...ch} />} />
                              {ch.children.map((ch1) => (
                                <>
                                  {ch1.children === undefined && (
                                    <Route path={ch1.route} element={<BrtxRoute {...this.props} {...ch1} />} />
                                  )}
                                  {ch1.children !== undefined && (
                                    <Route path={ch1.route}>
                                      <>
                                        <Route index element={<BrtxRoute {...this.props} {...ch1} />} />
                                        {ch1.children.map((ch2) => (
                                          <Route
                                            path={ch2.route}
                                            element={<BrtxRoute {...this.props} {...ch2} />}
                                          />
                                        ))}
                                      </>
                                    </Route>
                                  )}
                                </>
                              ))}
                            </>
                          </Route>
                        )}
                      </>
                    ))}
                  </>
                </Route>
              )}
            </>
          ))}

          {this.props.user?.auth?.map((r) => (
            <Route path={r.route} element={<BrtxRoute {...this.props} {...r} />} />
          ))}

        </Routes>
        {!this.props.noui && (
        <BrtxRoute {...Config({ DefaultRoutes: true }).filter((f) => f.element === "Footer")[0]} />
        )}
      </>
    );
  }
}

export default BrtxRoutes;
